import React from 'react'
import appTypeConfigFunc from 'apptype-config'
import loadable from '@loadable/component'
import { Spin } from 'antd'

const config = {
  fallback: <Spin />,
}

const defaultRoutes = [
  {
    path: '/auth/login_old',
    Component: loadable(() => import('pages/auth/login_old'), config),
    exact: true,
  },
  // {
  //   path: '/auth/login',
  //   Component: loadable(() => import('pages/auth/loginAdmin'), config),
  //   exact: true,
  // },
  {
    path: '/auth/login',
    Component: loadable(() => import('pages/auth/login'), config),
    exact: true,
  },
  {
    path: '/auth/sso/:key',
    Component: loadable(() => import('pages/auth/loginByKey'), config),
    exact: true,
  },
  {
    path: '/auth/sso',
    Component: loadable(() => import('pages/auth/loginByKey'), config),
    exact: true,
  },
  {
    path: '/provisioning',
    Component: loadable(() => import('pages/provisioning'), config),
    exact: true,
  },
  {
    path: '/provisioning/settings',
    Component: loadable(() => import('pages/provisioning'), config),
    exact: true,
  },
  // {
  //   path: '/auth/login2',
  //   Component: loadable(() => import('pages/auth/login2'), config),
  //   exact: true,
  // },
  // {
  //   path: '/redirect',
  //   Component: loadable(() => import('pages/auth/redirect'), config),
  //   exact: true,
  // },
  // // Auth Pages
  // {
  //   path: '/auth/login',
  //   Component: loadable(() => import('pages/auth/login'), config),
  //   exact: true,
  // },
  // {
  //   path: '/auth/forgot-password',
  //   Component: loadable(() => import('pages/auth/forgot-password'), config),
  //   exact: true,
  // },
  // {
  //   path: '/auth/register',
  //   Component: loadable(() => import('pages/auth/register'), config),
  //   exact: true,
  // },
  {
    path: '/auth/lockscreen',
    Component: loadable(() => import('pages/auth/lockscreen'), config),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: loadable(() => import('pages/auth/404'), config),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: loadable(() => import('pages/auth/500'), config),
    exact: true,
  },
]

// if (process.env.REACT_APP_TARGET !== 'production') {
defaultRoutes.push({
  path: '/provisioning/deleteDomain',
  Component: loadable(() => import('pages/provisioning/deleteDomain'), config),
  exact: true,
})

// defaultRoutes.push(  {
//   path: '/testProvisioning',
//   Component: loadable(() => import('pages/provisioning'), config),
//   exact: true,
// })
// }

const routeInfo = {
  prev: null,
  map: null,
}

export function clearRoutes() {
  routeInfo.prev = null
  routeInfo.map = null
}

export default function getRoutes() {
  const routerFunc = appTypeConfigFunc().router

  const myRoutes = [...defaultRoutes, ...routerFunc(config)]

  let isChanged = true
  if (routeInfo.prev != null) {
    isChanged = routeInfo.prev.length !== myRoutes.length
    if (isChanged === false) {
      if (routeInfo.map == null) {
        routeInfo.map = {}
        routeInfo.prev.forEach((item) => {
          routeInfo.map[item.path] = item
        })
      }
      isChanged = myRoutes.some((route) => {
        return routeInfo.map[route.path] == null
      })
    }
  }

  if (isChanged === true) {
    routeInfo.prev = myRoutes
    routeInfo.map = null
  } else {
    // routeInfo.prev.length = 0;
    // myRoutes.forEach((route) => {
    //   routeInfo.prev.push(route);
    // });
    return routeInfo.prev
  }

  return myRoutes
}

// export default function getRoutes() {
//   const routerFunc = appTypeConfigFunc().router

//   const myRoutes = [...defaultRoutes, ...routerFunc(config)]

//   return myRoutes
// }
